var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart-point-widget"},[(_vm.resolveWidgetComponent !== 'div')?_c(_vm.resolveWidgetComponent,{tag:"component",attrs:{"transporter":_vm.transporter}}):_vm._e(),_vm._v(" "),(_vm.resolveWidgetComponent !== 'div')?_c(_vm.resolveWidgetSelectionComponent,{tag:"component",attrs:{"transporter":_vm.transporter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }